import ApiService from '@/data/services/ApiService'
import { AxiosResponse } from 'axios'
import { IServiceResponse } from '@/data/models/ServiceResponse'

export interface IPlayerGroup {
  id: number;
  name: string;
}

export class PlayerGroupApiService extends ApiService {
  static async getAll(): Promise<IServiceResponse<IPlayerGroup[]>> {
    return this.axios.get('player-groups')
      .then((response: AxiosResponse<IServiceResponse<IPlayerGroup[]>>) => response.data)
  }

  static async create(name: string): Promise<IServiceResponse<IPlayerGroup>> {
    return this.axios.post('player-groups', { name })
      .then((response: AxiosResponse<IServiceResponse<IPlayerGroup>>) => response.data)
  }
}
